function carousel_action(button, special) {
    if(button.classList.contains("carousel_next") || button.classList.contains("container-list--carousel_button__next")){
        let carousel_selected = button.previousElementSibling;
        let carousel_item = carousel_selected.getAttribute("ItemClass");
        carousel_item = carousel_selected.getElementsByClassName(carousel_item);
        let move_position = carousel_item[0].offsetWidth + parseInt(window.getComputedStyle(carousel_item[0]).marginLeft) + parseInt(window.getComputedStyle(carousel_item[0]).marginRight);
        let trackWidth = move_position * carousel_item.length * -1;
        let actual_position = parseInt(carousel_selected.getAttribute("actualPosition"));
        let error_activated = (carousel_selected.getAttribute("errorActivated") === "true");
        if(special == false || special == null){
            carousel_next(button, carousel_selected, trackWidth, actual_position, move_position, error_activated);
        }else{
            carousel_next_special(button, carousel_selected, trackWidth, actual_position, move_position, error_activated);
        }
    }
    else {
        let carousel_selected = button.previousElementSibling.previousElementSibling;
        let actual_position = parseInt(carousel_selected.getAttribute("actualPosition"));
        let carousel_item = carousel_selected.getAttribute("ItemClass");
        carousel_item = carousel_selected.getElementsByClassName(carousel_item);
        let move_position = carousel_item[0].offsetWidth + parseInt(window.getComputedStyle(carousel_item[0]).marginLeft) + parseInt(window.getComputedStyle(carousel_item[0]).marginRight);
        let trackWidth = move_position * carousel_item.length * -1;
        let error_activated = (carousel_selected.getAttribute("errorActivated") === "true");
        carousel_prev(button, carousel_selected, trackWidth, actual_position, move_position, error_activated);
    }
}

function resize(carousel_selected, error_activated){
    let move_position = 0;
    if(window.innerWidth < 1201 && window.innerWidth > 1024){
        if(error_activated)
            move_position = 539;
        else
            move_position = 516;
        carousel_selected.setAttribute("movePosition", move_position);
    }
    else if (window.innerWidth < 1025 && window.innerWidth > 768){
        if(error_activated)
            move_position = 489;
        else
            move_position = 466;
        carousel_selected.setAttribute("movePosition", move_position);
    }
    else if (window.innerWidth < 769 && window.innerWidth > 481){
        if(error_activated)
            move_position = 498;
        else
            move_position = 472;
        carousel_selected.setAttribute("movePosition", move_position);
    }
    else if (window.innerWidth < 481 && window.innerWidth > 420){
        if(error_activated)
            move_position = 448;
        else
            move_position = 426;
        carousel_selected.setAttribute("movePosition", move_position);
    }
    else if (window.innerWidth < 420){
        if(error_activated)
            move_position = 398;
        else
            move_position = 372;
        carousel_selected.setAttribute("movePosition", move_position);
    }
    else {
        if(error_activated)
            move_position = 589;
        else
            move_position = 566;
        carousel_selected.setAttribute("movePosition", move_position);
    }
}

function carousel_next(button_next, carousel_selected, trackWidth, actual_position, move_position, error_activated) {
    if(actual_position > trackWidth){
        carousel_selected.scrollLeft += move_position;
        actual_position += move_position;
        carousel_selected.setAttribute("actualPosition", actual_position);
        if(actual_position + move_position == 0){
            error_activated = true;
        }     
    }
    if(((actual_position + window.innerWidth) * -1) <= trackWidth){
        button_next.style.display = "none";
    }
    if(actual_position > 0){
        let button_prev = button_next.nextElementSibling;
        button_prev.style.display = "flex";
    }
}
function carousel_next_special(button_next, carousel_selected, trackWidth, actual_position, move_position, error_activated) {
    if(actual_position > trackWidth){
        carousel_selected.scrollLeft += (move_position+2);
        actual_position += move_position;
        carousel_selected.setAttribute("actualPosition", actual_position);
        if(actual_position + move_position == 0){
            error_activated = true;
        }     
    }
    if((actual_position * -1) <= trackWidth+move_position){
        button_next.style.display = "none";
    }
    if(actual_position > 0){
        let button_prev = button_next.nextElementSibling;
        button_prev.style.display = "flex";
    }
}

function carousel_prev(button_prev, carousel_selected, trackwidth, actual_position, move_position, error_activated) {
    if(actual_position > 0){
        carousel_selected.scrollLeft -= move_position;
        actual_position -= move_position;
        carousel_selected.setAttribute("actualPosition", actual_position);
    }
    if(actual_position > trackwidth){
        let button_next = button_prev.previousElementSibling;
        button_next.style.display = "flex";
    }
    if(actual_position == 0){
        button_prev.style.display = "none";
    }
}

function showButton() {
    let button_next = document.getElementsByClassName("carousel_next");
    let carousel = document.getElementsByClassName("content_carousel");
    for(i=0; i< carousel.length; i++){
        let carousel_width = carousel[0].getElementsByClassName("content_card");
        carousel_width = (carousel_width[0].offsetWidth + parseInt(window.getComputedStyle(carousel_width[0]).marginLeft) + parseInt(window.getComputedStyle(carousel_width[0]).marginRight)) * carousel_width.length;
        if(carousel_width < window.innerWidth) {
            button_next[i].style.display = "none";
            carousel[i].style.margin = "auto";
        }
        else {
            button_next[i].style.display = "flex";
            carousel[i].style.margin = "auto";
        }
    }
}

window.onload = showButton;
window.onresize = showButton;

var colorVariable;
var background_format;

function setColor(color, format) {
    colorVariable = color;
    background_format = format;
}

function changePosition_special(carousel_selected){
    let leftScrolling = carousel_selected.scrollLeft;
    carousel_selected.setAttribute("actualPosition", leftScrolling);
    let carousel_item = carousel_selected.getAttribute("ItemClass");
    carousel_item = carousel_selected.getElementsByClassName(carousel_item);
    let move_position = carousel_item[0].offsetWidth + parseInt(window.getComputedStyle(carousel_item[0]).marginLeft) + parseInt(window.getComputedStyle(carousel_item[0]).marginRight);
    let trackWidth_aux = move_position * carousel_item.length;
    let big_carousel = carousel_selected.parentNode
    let button_next = big_carousel.getElementsByClassName("container-list--carousel_button__next");
    let button_prev = big_carousel.getElementsByClassName("container-list--carousel_button__prev");
    if(leftScrolling <= trackWidth_aux-move_position){
        button_next[0].style.display = "flex";
    }
    if(leftScrolling >= (trackWidth_aux-move_position)){
        button_next[0].style.display = "none";
    }
    if(leftScrolling > 0){
        button_prev[0].style.display = "flex";
    }
    if(leftScrolling == 0){
        button_prev[0].style.display = "none";
    }
}
function changePosition(carousel_selected){
    let leftScrolling = carousel_selected.scrollLeft;
    carousel_selected.setAttribute("actualPosition", leftScrolling);
    let carousel_item = carousel_selected.getAttribute("ItemClass");
    let button_next = carousel_selected.getAttribute("nextClass");
    let button_prev = carousel_selected.getAttribute("prevClass");
    carousel_item = carousel_selected.getElementsByClassName(carousel_item);
    let move_position = carousel_item[0].offsetWidth + parseInt(window.getComputedStyle(carousel_item[0]).marginLeft) + parseInt(window.getComputedStyle(carousel_item[0]).marginRight);
    let trackWidth_aux = move_position * carousel_item.length * -1;
    let big_carousel = carousel_selected.parentNode
    button_next = big_carousel.getElementsByClassName(button_next);
    button_prev = big_carousel.getElementsByClassName(button_prev);
    if(leftScrolling > trackWidth_aux){
        button_next[0].style.display = "flex";
    }
    if(((leftScrolling + window.innerWidth) * -1) <= trackWidth_aux){
        button_next[0].style.display = "none";
    }
    if(leftScrolling > 0){
        button_prev[0].style.display = "flex";
    }
    if(leftScrolling == 0){
        button_prev[0].style.display = "none";
    }
}

var colorBackground = () => {
    let size = window.matchMedia('(max-width: 880px)');
    let height;
    if(background_format){
        height = '58%';
    }else{
        height = '100%';
    }
    if ( size.matches ) {
        let background = "linear-gradient(" + colorVariable + " " + height + " , " +  colorVariable + " " + height + ")";
        document.getElementById('carousel').style.background = background;
    } else {
        let color2 = '#F5F4E2';
        let background = "linear-gradient(" + colorVariable + " " + height + " , " + color2 + " " + height + ")";
        document.getElementById('carousel').style.background = background;
    }
}

function configure(colorFunction) {
    window.addEventListener('load', colorFunction);
    window.addEventListener("change", colorFunction);
    window.addEventListener("resize", colorFunction);
}
